/* eslint-disable react-hooks/exhaustive-deps */
import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Alert, Box, Snackbar, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import Sidebar from './Sidebar';
import Header from './Header';
import HeaderOnlineMedia from './HeaderOnlineMedia';
import HeaderOnlineMediaClipping from './HeaderOnlineMediaClipping';
import HeaderSocialMediaStream from './HeaderSocialMediaStream';
import HeaderSettings from './HeaderSettings';
import HeaderCustomDashboard from './HeaderCustomDashboard';
import TopHeader from './Header/Top';
import { useLocation, useNavigate } from 'react-router';
import {
  ONLINE_MEDIA_CLIPPING,
  SOCIAL_MEDIA_CAMPAIGN,
  STREAM_PANEL_ONLINE_MEDIA,
  STREAM_PANEL_SOCIAL_MEDIA,
  SETTINGS,
  ONLINE_MEDIA_STATISTIC,
  CUSTOM_DASHBOARD,
  ADD_AUTO_LABEL,
  SOCIAL_MEDIA_COMPARISON,
  SOCIAL_MEDIA_ADD_COMPARISON,
  ONLINE_MEDIA_COMPARISON,
  PEOPLE_PANEL,
  STREAM_PANEL_OFFLINE_MEDIA,
  OFFLINE_MEDIA_STATISTIC,
  CUSTOM_REPORT,
  ADD_AUTO_LABEL_ONM,
  SETTINGS_LABEL,
  OFFLINE_MEDIA_CLIPPING,
  OFFLINE_MEDIA_COMPARISON,
  CHAT_NOW_CHAT_HISTORY,
  CHAT_NOW_NEW_CHAT,
  CHAT_NOW_GUIDELINES,
  GOOGLE_REVIEW_COMPARISON,
  OVERVIEW,
  CUSTOM_REPORT_NEWSLATTER,
  SOCIAL_MEDIA,
  ECOMMERCE_COMPARISON,
  ECOMMERCE_STREAM,
  VIDEO_TUTORIAL,
  ADD_AUTO_LABEL_ECOMMERCE
} from 'src/route';
import HeaderOnlineMediaClippingById from './HeaderOnlineMediaClippingById';
import useQueryUrl from 'src/hooks/useQuery';
import HeaderSocialMediaHashtag from './HeaderSocialMediaHashtag';
import HeaderPreferenceCampaign from './HeaderPreferenceCampaign';
import MinimalistHeader from './MinimalistHeader';
import HeaderOnlineMediaStatistic from './HeaderOnlineMediaStatistic';
import HeaderComparisonDashboard from './HeaderComparisonDashboard';
import HeaderComparisonOnm from './HeaderComparisonOnm';
import { useAlert } from 'src/hooks/useAlert';
import { useAppSelector } from 'src/app/hooks';
import { useTopNotification } from 'src/hooks/useTopNotification';
import TopNotification from '../components/TopNotification';
import HeaderPeoplePanel from './HeaderPeoplePanel';
import HeaderOfflineMedia from './HeaderOfflineMedia';
import HeaderOfflineMediaStatistic from './HeaderOfflineMediaStatistic';
import HeaderCustomReport from './HeaderCustomReport';
import HeaderCustomReportById from './HeaderCustomReportById';
import HeaderOfflineMediaClippingById from './HeaderOfflineMediaClippingById';
import HeaderOfflineMediaComparison from 'src/layouts/SidebarLayout/HeaderOfflineMediaComparison';
import HeaderChatNowNewChat from './HeaderChatNowNewChat';
import useGoogleReview from 'src/services/useGoogleReview';
import PipNewChat from 'src/components/PipChatNow';
import HeaderOverview from './HeaderOverview';
import HeaderNewsLetterById from './HeaderNewsLetterById';
import ModalProductTour from 'src/components/ModalProductTour';
import BlackScreenComponent from './BlackScreenComponent';
import ScrollRefProvider from './Sidebar/ScrollRefProvider';
import UnSupportPage from 'src/components/UnSupportPage';
import PopulatingDataProgress from 'src/components/PopulatingDataProgress';
import FloatingButtons from './components/FloatingButtons';
import HeaderEcommerceStream from './HeaderEcommerceStream';
import useEcommerce from 'src/services/useEcommerce';
import useBillingSystem from 'src/services/useBillingSystem';
import TopHeaderV2 from '../../components/Retail/TopV2';
import HeaderRetail from 'src/components/Retail/Headers/Header';
import HeaderOnlineMediaRetail from 'src/components/Retail/Headers/HeaderOnlineMedia';
import HeaderSocialMediaStreamRetail from 'src/components/Retail/Headers/HeaderSocialMediaStream';
import ChatNowRetail from 'src/components/Retail/ChatNowRetail';
import HeaderOnlineMediaStatisticRetail from 'src/components/Retail/Headers/HeaderOnlineMediaStatistic';
import HeaderOnlineMediaClippingByIdRetail from 'src/components/Retail/Headers/HeaderOnlineMediaClippingByIdRetail';
import HeaderSocialMediaHashtagRetail from 'src/components/Retail/Headers/HeaderSocialMediaHashtag';
import HeaderComparisonDashboardRetail from 'src/components/Retail/Headers/HeaderComparisonDashboard';
import HeaderComparisonOnmRetail from 'src/components/Retail/Headers/HeaderComparisonOnm';
import moment from 'moment';
import HeaderComparisonDashboardEcommerce from './HeaderComparisonDashboardEcommerce';

interface SidebarLayoutProps {
  children?: ReactNode;
}

interface MainBodyProps {
  isOnTour: boolean;
  isRetail?: boolean;
}

const MainWrapper = styled(Box)(
  ({ theme }) => `
    width: 100vw;
    height: 100%;
    position: relative;
    display: flex;
    flex: 1 1 0%;
    background: white;
    cursor: default
`
);

const MainContent = styled(Box)<{ isOnTour: boolean }>(
  ({ theme, isOnTour }) => `
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    ${isOnTour && 'min-height: 100vh;'}
`
);

const MainBody = styled(Box)<MainBodyProps>(
  ({ theme, isOnTour, isRetail = false }) => `
  flex-grow: 0;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  background: ${isRetail ? '#F5F5F5' : theme.palette.grey[50]};
  ${!isOnTour && 'z-index: 1;'}
  height: calc(100vh - 45px);
  max-height: 100%;
  position: relative;
  overflow: auto;
`
);

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const { handleCloseAlert, handleClickAlert } = useAlert();
  const stateAlert = useAppSelector((state) => state.storeAlert.alert);
  const {
    status,
    isProviderLtd,
    subscriptionEndDate: endDateString,
    customerType,
    id: projectId,
    timezone
  } = useAppSelector((state) => state.users.project);
  // const { comparisonList } = useAppSelector((state) => state.storeComparison);
  const { useGetGoogleComparisonList } = useGoogleReview();
  const [getGoogleComparisonList, { data: googleComparisonList }] =
    useGetGoogleComparisonList();
  const { useGetEcommerceObjectList, useGetEcommerceLabel } = useEcommerce();
  const [getEcommerceObjectList] = useGetEcommerceObjectList();
  const [getEcommerceLabel] = useGetEcommerceLabel();
  const { isPictureInPictureMode } = useAppSelector((state) => state.chatNow);
  const { isOnTour, isTourButtonOpen } = useAppSelector(
    (state) => state.storeProductTour
  );
  const { isOpen: isAIAssistantOpen, position: positionAIAssistant } =
    useAppSelector((state) => state.storeAIAssistantPosition);

  const subscriptionEndDate = new Date(endDateString);
  const { pathname } = useLocation();
  const pathValue = pathname.split('/')[3];
  const pathValueSetting = pathname.split('/')[2];
  const pathValueComparison = pathname.split('/')[4];
  const query = useQueryUrl();
  const preferences = query.get('preferences');
  const history = query.get('history');
  const tabComparison = query.get('tab');
  const navigator = useNavigate();
  const theme = useTheme();
  const { handleShowTopNotification, handleCloseNotification } =
    useTopNotification();

  const getTopPadding = () => {
    switch (pathname) {
      // case STREAM_PANEL_SOCIAL_MEDIA:
      //   return 0;
      // case STREAM_PANEL_ONLINE_MEDIA:
      // return portalId ? 0 : 0;
      // case `${ONLINE_MEDIA_CLIPPING}/${pathValue}`:
      //   return 0;
      case ONLINE_MEDIA_CLIPPING:
        return 4;
      case OFFLINE_MEDIA_CLIPPING:
        return 4;
      case SOCIAL_MEDIA_CAMPAIGN:
        if (!preferences && !history) return 0;
        return 3;
      case `${SETTINGS}/${pathValueSetting}`:
        return 4;
      case SETTINGS:
        return 4;
      case ADD_AUTO_LABEL:
        return 4;
      case ADD_AUTO_LABEL_ECOMMERCE:
        return 4;
      case ADD_AUTO_LABEL_ONM:
        return 4;
      case SOCIAL_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      case ONLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      case OFFLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      case `${SOCIAL_MEDIA_ADD_COMPARISON}/${pathValueComparison}`:
        return 4;
      case CUSTOM_DASHBOARD:
        return 4;
      case `${CUSTOM_DASHBOARD}/${pathValue}`:
        return 12;
      case CUSTOM_REPORT:
        return 4;
      case OVERVIEW:
        return 0;
      case ECOMMERCE_COMPARISON:
        if (tabComparison === 'dashboard') return 0;
        return 4;
      default:
        return 0;
    }
  };

  const menuName = timezone === 7 ? 'Custom Dashboard' : 'Instant Insight';
  const isRetail = customerType === 'b2c';

  const getHeader = () => {
    switch (pathname) {
      case STREAM_PANEL_SOCIAL_MEDIA:
        return isRetail ? (
          <HeaderSocialMediaStreamRetail />
        ) : (
          <HeaderSocialMediaStream />
        );
      case STREAM_PANEL_ONLINE_MEDIA:
        return isRetail ? <HeaderOnlineMediaRetail /> : <HeaderOnlineMedia />;
      case STREAM_PANEL_OFFLINE_MEDIA:
        return <HeaderOfflineMedia />;
      case PEOPLE_PANEL:
        return <HeaderPeoplePanel />;
      case ONLINE_MEDIA_CLIPPING:
        return isRetail ? null : <HeaderOnlineMediaClipping />;
      case OFFLINE_MEDIA_CLIPPING:
        return <HeaderOnlineMediaClipping />;
      case `${ONLINE_MEDIA_CLIPPING}/${pathValue}`:
        return isRetail ? (
          <HeaderOnlineMediaClippingByIdRetail />
        ) : (
          <HeaderOnlineMediaClippingById />
        );
      case `${OFFLINE_MEDIA_CLIPPING}/${pathValue}`:
        return <HeaderOfflineMediaClippingById />;
      case ONLINE_MEDIA_STATISTIC:
        return isRetail ? (
          <HeaderOnlineMediaStatisticRetail />
        ) : (
          <HeaderOnlineMediaStatistic />
        );
      case OFFLINE_MEDIA_STATISTIC:
        return <HeaderOfflineMediaStatistic />;
      case ONLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard')
          return isRetail ? (
            <HeaderComparisonOnmRetail />
          ) : (
            <HeaderComparisonOnm onClick={() => navigator(SETTINGS)} />
          );
        return isRetail ? null : (
          <MinimalistHeader
            onClick={() => navigator(ONLINE_MEDIA_COMPARISON)}
            title={pathValueSetting}
            showBackButton={false}
          />
        );
      case OFFLINE_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard')
          return (
            <HeaderOfflineMediaComparison onClick={() => navigator(SETTINGS)} />
          );
        return (
          <MinimalistHeader
            onClick={() => navigator(OFFLINE_MEDIA_COMPARISON)}
            title={pathValueSetting}
            showBackButton={false}
          />
        );
      case SOCIAL_MEDIA_CAMPAIGN:
        if (!preferences && !history)
          return isRetail ? (
            <HeaderSocialMediaHashtagRetail />
          ) : (
            <HeaderSocialMediaHashtag />
          );
        if (preferences) return <HeaderPreferenceCampaign />;
        return (
          <MinimalistHeader
            onClick={() => navigator(SOCIAL_MEDIA_CAMPAIGN)}
            title="Campaign History"
          />
        );
      case SOCIAL_MEDIA_COMPARISON:
        if (tabComparison === 'dashboard')
          return isRetail ? (
            <HeaderComparisonDashboardRetail
              onClickBack={() => navigator(SOCIAL_MEDIA_COMPARISON)}
            />
          ) : (
            <HeaderComparisonDashboard
              onClickBack={() => navigator(SOCIAL_MEDIA_COMPARISON)}
            />
          );
        return isRetail ? null : (
          <MinimalistHeader
            onClick={() => navigator(SOCIAL_MEDIA_COMPARISON)}
            title={pathValueSetting}
            showBackButton={false}
          />
        );
      case `${SOCIAL_MEDIA_ADD_COMPARISON}/${pathValueComparison}`:
        return isRetail ? null : (
          <MinimalistHeader
            onClick={() => navigator(SOCIAL_MEDIA_COMPARISON)}
            title={pathValueSetting}
          />
        );
      case SETTINGS:
        return customerType === 'b2c' ? <></> : <HeaderSettings />;
      case `${SETTINGS}/${pathValueSetting}`:
        return (
          <MinimalistHeader
            onClick={() => navigator(SETTINGS)}
            title={pathValueSetting}
          />
        );
      case CUSTOM_DASHBOARD:
        return isRetail ? null : (
          <MinimalistHeader
            onClick={() => {}}
            title={menuName}
            showBackButton={false}
          />
        );
      case `${CUSTOM_DASHBOARD}/${pathValue}`:
        return <HeaderCustomDashboard />;
      case `${ADD_AUTO_LABEL}`:
        return (
          <MinimalistHeader
            onClick={() => navigator(SETTINGS)}
            title={'Label'}
          />
        );
      case `${ADD_AUTO_LABEL_ECOMMERCE}`:
        return (
          <MinimalistHeader
            onClick={() => navigator(SETTINGS)}
            title={'Auto Label Ecommerce'}
          />
        );
      case `${ADD_AUTO_LABEL_ONM}`:
        return (
          <MinimalistHeader
            onClick={() => navigator(`${SETTINGS_LABEL}?tab=auto_label_onm`)}
            title="Label Article"
          />
        );
      case CUSTOM_REPORT:
        return isRetail ? null : <HeaderCustomReport />;
      case `${CUSTOM_REPORT_NEWSLATTER}`:
        return <HeaderNewsLetterById />;
      case `${CUSTOM_REPORT}/${pathValue}`:
        return <HeaderCustomReportById />;
      case CHAT_NOW_NEW_CHAT:
        return <HeaderChatNowNewChat />;
      case CHAT_NOW_CHAT_HISTORY:
        return (
          <MinimalistHeader
            onClick={() => {}}
            showBackButton={false}
            title="Chat History"
          />
        );
      case CHAT_NOW_GUIDELINES:
        return (
          <MinimalistHeader
            onClick={() => navigator(-1)}
            showBackButton
            title="Guidelines"
          />
        );
      case GOOGLE_REVIEW_COMPARISON:
        if (tabComparison === 'dashboard')
          return (
            <HeaderComparisonDashboard
              onClickBack={() => navigator(GOOGLE_REVIEW_COMPARISON)}
            />
          );
        return (
          <MinimalistHeader
            onClick={() => navigator(GOOGLE_REVIEW_COMPARISON)}
            title={pathValueSetting}
            showBackButton={false}
          />
        );
      case ECOMMERCE_COMPARISON:
        if (tabComparison === 'dashboard')
          return (
            <HeaderComparisonDashboardEcommerce
              onClickBack={() => navigator(ECOMMERCE_COMPARISON)}
            />
          );
        return (
          <MinimalistHeader
            onClick={() => navigator(ECOMMERCE_COMPARISON)}
            title={pathValueSetting}
            showBackButton={false}
          />
        );

      case ECOMMERCE_STREAM:
        return <HeaderEcommerceStream />;

      case OVERVIEW:
        return isRetail ? null : (
          <HeaderOverview
            onClick={() => navigator(-1)}
            showBackButton={false}
            title="Overview"
          />
        );
      case VIDEO_TUTORIAL:
        return (
          <MinimalistHeader
            onClick={() => navigator(-1)}
            showBackButton
            title="Video Tutorial"
          />
        );
      default:
        return isRetail ? <HeaderRetail /> : <Header />;
    }
  };

  //responsive sidebar
  const matchesUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const { useGetUserSubscription } = useBillingSystem();

  const { data: subscriptionData, loading: isLoading } = useGetUserSubscription(
    { variables: { projectId: projectId }, skip: !projectId }
  );

  const isFreeTrial =
    subscriptionData?.billing_getUserSubscription?.currentUserCycle
      ?.userSubscriptionCycle?.isFreeTrial;
  const freeTrialDuration = moment(
    subscriptionData?.billing_getUserSubscription?.currentUserCycle
      ?.userSubscriptionCycle?.periodEnd
  ).diff(
    subscriptionData?.billing_getUserSubscription?.currentUserCycle
      ?.userSubscriptionCycle?.periodStart,
    'day'
  );

  useEffect(() => {
    getGoogleComparisonList({ variables: { projectId } });
    getEcommerceObjectList({ variables: { projectId } });
    getEcommerceLabel({ variables: { projectId, category: 'ecommerce' } });
  }, [projectId]);

  useEffect(() => {
    if (
      !status ||
      isProviderLtd ||
      customerType === 'b2b' ||
      !subscriptionEndDate
    )
      return;

    if (isFreeTrial) {
      handleShowTopNotification({
        message: `You’re currently on a ${freeTrialDuration}-day free trial. Upgrade your subscription to monitor more brands, get higher quotas, and enjoy longer access. Manage your billing`,
        severity: 'info',
        showCloseButton: true
      });
    }

    if (status === 'active') return;

    const terminatedDate = new Date(subscriptionEndDate);
    terminatedDate.setDate(terminatedDate.getDate() + 14);

    if (status === 'almost_on_hold') {
      const remainingDays = Math.round(
        (subscriptionEndDate.getTime() - new Date().getTime()) /
          (1000 * 3600 * 24)
      );
      handleShowTopNotification({
        message: `Your next billing is due in ${remainingDays} ${
          remainingDays > 1 ? 'days' : 'day'
        } - `,
        severity: 'warning',
        showCloseButton: true
      });
    } else if (status === 'on_hold') {
      handleShowTopNotification({
        message:
          'You’re on a grace period! Your subscription data are on hold - ',
        severity: 'error',
        showCloseButton: false
      });
    } else if (status === 'almost_terminated') {
      const remainingDays = Math.round(
        (new Date().getTime() - terminatedDate.getTime()) / (1000 * 3600 * 24)
      );
      handleShowTopNotification({
        message: `Your plan has expired! Your subscription data will not be updated in the next ${remainingDays} ${
          remainingDays > 1 ? 'days' : 'day'
        } - `,
        severity: 'error',
        showCloseButton: false
      });
    } else if (status === 'terminated') {
      handleShowTopNotification({
        message:
          'Access to your dashboard and insights is currently unavailable. Please manage your billing to regain access. - ',
        severity: 'error',
        showCloseButton: false
      });
    } else {
      handleCloseNotification();
    }
  }, [
    status,
    subscriptionEndDate,
    customerType,
    isFreeTrial,
    freeTrialDuration
  ]);

  const matchedMediaUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const [openAnounce, setOpenAnounce] = useState(false);
  useEffect(() => {
    if (
      !matchedMediaUpMd &&
      (pathname?.includes(
        `${SOCIAL_MEDIA}/sna` ||
          `${SOCIAL_MEDIA}/dna` ||
          `${SOCIAL_MEDIA}/clustering`
      ) ||
        pathname?.includes(`${SOCIAL_MEDIA}/dna`) ||
        pathname?.includes(`${SOCIAL_MEDIA}/clustering`))
    ) {
      setOpenAnounce(true);
      return;
    }
    setOpenAnounce(false);
  }, [matchedMediaUpMd, pathname]);

  const bodyRef = useRef(null);

  useEffect(() => {
    if (isTourButtonOpen) {
      if (bodyRef?.current) {
        bodyRef?.current?.scrollTo({
          top: 0
        });
      }
    }
  }, [isTourButtonOpen]);

  useEffect(() => {
    if (isOnTour) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = 'auto';
    } else {
      document.body.style.overflow = 'auto';
      document.body.style.height = '100%';
    }
  }, [isOnTour]);

  const sidePositionAIAssistant =
    isAIAssistantOpen && positionAIAssistant === 'side';

  return (
    <>
      <ScrollRefProvider>
        {(isTourButtonOpen || isOnTour) && <BlackScreenComponent />}
        {(isTourButtonOpen || isOnTour) && <ModalProductTour />}
        <MainWrapper>
          {matchesUpMd && <Sidebar />}
          <MainContent isOnTour={isOnTour}>
            {isRetail ? <TopNotification /> : null}
            {isRetail ? <TopHeaderV2 /> : <TopHeader />}
            <ErrorBoundary
              FallbackComponent={() => <></>}
              onError={(error: Error, info) => {
                handleClickAlert({
                  horizontal: 'center',
                  vertical: 'top',
                  message: 'Something went wrong',
                  severity: 'error'
                });
                console.log(error, info.componentStack);
              }}
            >
              <MainBody isOnTour={isOnTour} isRetail={isRetail} ref={bodyRef}>
                {getHeader()}
                <Box
                  sx={{
                    px: 4,
                    pt: getTopPadding(),
                    pb: 4,
                    background: isRetail ? '#F5F5F5' : theme.palette.grey[50]
                  }}
                >
                  <Outlet />
                </Box>
              </MainBody>
            </ErrorBoundary>
          </MainContent>
          {sidePositionAIAssistant && (
            <ChatNowRetail mode="normal" customWidthPercentage="37%" />
          )}
        </MainWrapper>
        <Snackbar
          anchorOrigin={{
            vertical: stateAlert.vertical,
            horizontal: stateAlert.horizontal
          }}
          open={stateAlert.open}
          onClose={handleCloseAlert}
          autoHideDuration={10000}
        >
          <Alert
            onClose={handleCloseAlert}
            severity={stateAlert.severity}
            sx={{ width: '100%' }}
          >
            {stateAlert.message}
            {stateAlert.action}
          </Alert>
        </Snackbar>
        <FloatingButtons />
        {isPictureInPictureMode &&
          (isRetail ? (
            <ChatNowRetail mode="pip" isVisible={isPictureInPictureMode} />
          ) : (
            <PipNewChat isVisible={isPictureInPictureMode} />
          ))}
        <UnSupportPage
          open={openAnounce}
          onClose={() => {
            setOpenAnounce(false);
            navigator('/');
          }}
        />
      </ScrollRefProvider>
    </>
  );
};

export default SidebarLayout;
